import BaseAPI from './base.api.service'

const resource = 'airfares';
export default {
    async getAirfare(erID) {
        return await BaseAPI.get(`expensereports/${erID}/Airfare`);
    },
    async getAirlineTypes() {
        return await BaseAPI.get(`${resource}/Airlines`);
    },
    async getNonRefundableTypes() {
        return await BaseAPI.get(`${resource}/NonRefundableTypes`)
    },
    async getForeignAirlineReasons() {
        return await BaseAPI.get(`${resource}/ForeignAirlineReasonTypes`)
    },
    async getFirstClassTypes() {
        return await BaseAPI.get(`${resource}/FirstClassTypes`)
    }
} 